export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_09.2a9e8ce4.jpg";